import { marketingAdministratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { marketingListFieldComponents } from "./marketingListFieldComponents";
import { marketingListPageConfig } from "./marketingListPageConfig";

export const marketingListRecordDefinition: RecordDefinition = {
  path: "/static-marketing-list",
  entityName: "list",
  listRoute: "/static-marketing-lists",
  backTitle: "Back to static marketing lists",
  allowedRoles: marketingAdministratorRoles,
  config: marketingListPageConfig,
  fieldComponents: marketingListFieldComponents,
  // One fixed layout: no extra views and no designer.
  authorable: false,
  // Contact is the legacy "Targeted At" default (TargetedAtType.Contact).
  newRecord: { createdfromcode: 2, g4c_issubscription: false },
  identity: {
    titleFields: ["listname"],
    fallbackTitle: "Static Marketing List",
    newRecordTitle: "New Static Marketing List",
  },
};
